import type { AxiosInstance, AxiosResponse } from "axios";
import type { StandardSchemaV1 } from "@standard-schema/spec";
import { SCHEMA_ERROR_MESSAGE } from "../../../core/request/error-messages";
import { getKsLangType } from "../../../utils/ksStorage";

declare module "axios" {
  interface AxiosRequestConfig {
    schema?: {
      response?: StandardSchemaV1 | null;
    };
  }
}

export class SchemaError extends Error {
  constructor(
    public readonly response: AxiosResponse,
    public readonly issues: ReadonlyArray<StandardSchemaV1.Issue>,
  ) {
    // 接口本身返回成功（2xx），此为前端数据结构校验失败。
    // 给用户展示统一友好文案（不暴露校验库 issue 详情，换库也不变）；
    // 具体 issue 详情已由 responseInterceptor console.error 输出供调试。
    super(
      getKsLangType() === "zh"
        ? SCHEMA_ERROR_MESSAGE.zh
        : SCHEMA_ERROR_MESSAGE.en,
    );
  }
}

export async function responseInterceptor(res: AxiosResponse) {
  const schema = res?.config.schema?.response;
  if (schema) {
    const parsedResult = schema['~standard'].validate(res.data);
    const result = parsedResult instanceof Promise ? await parsedResult : parsedResult;
    if ('issues' in result && result.issues) {
      const url = res.config.baseURL ? `${res.config.baseURL}${res.config.url}` : res.config.url;
      const action = res.config.params?.Action ? `?Action=${res.config.params.Action}` : "";
      console.error(
        `[schema-axios-contrib] response schema check failed for ${url}${action}`,
        result.issues,
      );
      throw new SchemaError(res, result.issues);
    }
  }

  return res;
}

export function checkResponseSchema(ins: AxiosInstance) {
  console.debug("[schema-axios-contrib] register response schema check");
  ins.interceptors.response.use(responseInterceptor);
  return ins;
}
